import { __read, __spreadArray, __values } from "tslib";
import { HubTileID } from '@office-start/appbar-types';
import { getFirstPartyWorkloadId, useDefaultHubApps, } from '@office-start/data-resolver-app-pinning';
import { useIdentity } from '@office-start/identity-service';
import { useLocStrings } from '@office-start/loc-service';
import { useWorkloads } from '@office-start/workloads-service';
import * as React from 'react';
/**
 * Custom React Hook responsible for resolving default hub tile data
 */
export function useHubTileData() {
    var locStrings = useLocStrings().data;
    var identity = useIdentity().data;
    var workloads = useWorkloads().data;
    var defaultApps = useDefaultHubApps();
    var resources = locStrings === null || locStrings === void 0 ? void 0 : locStrings.appBarResources;
    React.useEffect(function () {
        var e_1, _a;
        if (resources) {
            try {
                for (var tileData_1 = __values(tileData), tileData_1_1 = tileData_1.next(); !tileData_1_1.done; tileData_1_1 = tileData_1.next()) {
                    var edge = tileData_1_1.value;
                    switch (edge.node.id) {
                        case HubTileID.home:
                            edge.node.name = edge.node.accessibleName =
                                resources.homeTileName;
                            break;
                        case HubTileID.create:
                            edge.node.name = edge.node.accessibleName =
                                resources.createTileName;
                            break;
                        case HubTileID.mycontent:
                            edge.node.name = edge.node.accessibleName =
                                resources.myContentTileName;
                            break;
                        case HubTileID.orion:
                            edge.node.name = edge.node.accessibleName =
                                resources.orionTileName;
                            break;
                        case HubTileID.feed:
                            edge.node.name = edge.node.accessibleName =
                                resources.feedTileName;
                            break;
                        case HubTileID.appgallery:
                            edge.node.name = edge.node.accessibleName =
                                resources.flyoutButtonText;
                            break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (tileData_1_1 && !tileData_1_1.done && (_a = tileData_1.return)) _a.call(tileData_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            setTileData(__spreadArray([], __read(tileData), false));
        }
    }, [resources]);
    React.useEffect(function () {
        var e_2, _a;
        if (workloads && identity) {
            var isMsa = identity.isMsa;
            var allWorkloads = __spreadArray(__spreadArray([], __read(workloads.coreAndSegmentApps), false), __read(workloads.nonCoreAndSegmentApps), false);
            var _loop_1 = function (edge) {
                var firstPartyWorkloadId = getFirstPartyWorkloadId(edge.node.id, isMsa);
                var workload = allWorkloads.find(function (workload) { return workload.Id === firstPartyWorkloadId; });
                if (workload) {
                    // Get the tile name and accessible name from the NavBarData
                    edge.node.name = workload.Text;
                    edge.node.accessibleName = workload.Title;
                }
            };
            try {
                for (var tileData_2 = __values(tileData), tileData_2_1 = tileData_2.next(); !tileData_2_1.done; tileData_2_1 = tileData_2.next()) {
                    var edge = tileData_2_1.value;
                    _loop_1(edge);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (tileData_2_1 && !tileData_2_1.done && (_a = tileData_2.return)) _a.call(tileData_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
            setTileData(__spreadArray([], __read(tileData), false));
        }
    }, [workloads, identity]);
    var _a = __read(React.useState(function () {
        var launchTiles = [
            {
                node: {
                    id: HubTileID.home,
                    name: resources === null || resources === void 0 ? void 0 : resources.homeTileName,
                    accessibleName: resources === null || resources === void 0 ? void 0 : resources.homeTileName,
                    icon: {
                        __typename: 'InternalIcon',
                        name: 'HomeIcon',
                    },
                    selectedStateIconOverride: {
                        __typename: 'InternalIcon',
                        name: 'HomeIconSelected',
                    },
                    canLaunchOut: true,
                    isPinnable: false,
                    enablePlatformCommands: false,
                    lockedIndex: undefined,
                    pinnedIndex: undefined,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.create,
                    name: resources === null || resources === void 0 ? void 0 : resources.createTileName,
                    icon: {
                        __typename: 'InternalIcon',
                        name: 'CreateIcon',
                    },
                    selectedStateIconOverride: {
                        __typename: 'InternalIcon',
                        name: 'CreateIconSelected',
                    },
                    canLaunchOut: true,
                    isPinnable: false,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.mycontent,
                    name: resources === null || resources === void 0 ? void 0 : resources.myContentTileName,
                    icon: {
                        __typename: 'InternalIcon',
                        name: 'MyContentIcon',
                    },
                    selectedStateIconOverride: {
                        __typename: 'InternalIcon',
                        name: 'MyContentIconSelected',
                    },
                    canLaunchOut: true,
                    isPinnable: false,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.orion,
                    name: resources === null || resources === void 0 ? void 0 : resources.orionTileName,
                    icon: {
                        __typename: 'InternalIcon',
                        name: 'MyContentIcon',
                    },
                    selectedStateIconOverride: {
                        __typename: 'InternalIcon',
                        name: 'MyContentIconSelected',
                    },
                    canLaunchOut: true,
                    isPinnable: false,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.feed,
                    name: resources === null || resources === void 0 ? void 0 : resources.feedTileName,
                    icon: {
                        __typename: 'InternalIcon',
                        name: 'FeedIcon',
                    },
                    selectedStateIconOverride: {
                        __typename: 'InternalIcon',
                        name: 'FeedIconSelected',
                    },
                    canLaunchOut: true,
                    isPinnable: false,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.appgallery,
                    name: resources === null || resources === void 0 ? void 0 : resources.flyoutButtonText,
                    icon: {
                        __typename: 'InternalIcon',
                        name: 'AppsIcon',
                    },
                    selectedStateIconOverride: {
                        __typename: 'InternalIcon',
                        name: 'AppsIconSelected',
                    },
                    canLaunchOut: true,
                    isPinnable: false,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.outlook,
                    name: 'Outlook',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/outlook_24x.59692ba8e1f344194426952916c16896.svg',
                    },
                    brandingColor: '#0078D7',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.onedrive,
                    name: 'OneDrive',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/onedrive_24x.48ff325b96939ffeb92ab7ba4dc237d1.svg',
                    },
                    brandingColor: '#0078D7',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.teams,
                    name: 'Teams',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/teams_24x.1da2a0886d3c616a6242b1f249a9bdce.svg',
                    },
                    brandingColor: '#5558AF',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.word,
                    name: 'Word',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/word_24x.21f886b59cf807ae5818458ffa8cecd4.svg',
                    },
                    brandingColor: '#2B579A',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.excel,
                    name: 'Excel',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/excel_24x.067c6a6a32c636ef30bc50ddb143b7d9.svg',
                    },
                    brandingColor: '#217346',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.powerpoint,
                    name: 'PowerPoint',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/powerpoint_24x.5326aeabae2168deb16e6da825978d4f.svg',
                    },
                    brandingColor: '#B7472A',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.onenote,
                    name: 'OneNote',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/onenote_24x.84709e2492984ff1f10c0c1e4cd3dae6.svg',
                    },
                    brandingColor: '#7719AA',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.sway,
                    name: 'Sway',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/sway_24x.9c22be76a16820bd5a29a987de9d305e.svg',
                    },
                    brandingColor: '#008272',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.forms,
                    name: 'Forms',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/forms_24x.01909bf15ef50ec31db9988e84cecd16.svg',
                    },
                    brandingColor: '#008272',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.admin,
                    name: 'Admin',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 
                        // Temporarily using a hard-coded icon URL from the shell CDN.
                        // To be replaced with a more robust icon story all-up for all URL based icons.
                        // Product Backlog Item 5974110: Change how we do SVG icons in AppBar in Office.com
                        'https://res-1.cdn.office.net/shellux/admin_24x.8b38efcc63cc87244d60058f2677e22c.svg',
                    },
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.visio,
                    name: 'Visio',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/visio_24x.c475b8c5b0c9e2f8117ef74d4d61542b.svg',
                    },
                    brandingColor: '#3955A3',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.stream,
                    name: 'Stream',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/stream_24x.c63c42e913878cb9893f15fed2502c2b.svg',
                    },
                    brandingColor: '#C30052',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.todo,
                    name: 'ToDo',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/todo_24x.efcbeee6bef8b16fcebf3174335d91bb.svg',
                    },
                    brandingColor: '#00AFF0',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.familysafety,
                    name: 'Family Safety',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/familysafety_24x.c8729c60957826249cdc4a3ff6ae7da6.svg',
                    },
                    brandingColor: '#0C9D8C',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.calendar,
                    name: 'Calendar',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/calendar_24x.102f9e31d85b6335f286b6850da33f4a.svg',
                    },
                    brandingColor: '#0072C6',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.skype,
                    name: 'Skype',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/skype_24x.4d805c0782f5d0f1fbe48a3e78a6a5c6.svg',
                    },
                    brandingColor: '#00AFF0',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.people,
                    name: 'People',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/people_24x.897015202ac96f22ef9c79762255b645.svg',
                    },
                    brandingColor: '#0072C6',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.powerautomate,
                    name: 'Power Automate',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/powerautomate_24x.cb65672f4be34cbee045be6c6231e7e6.svg',
                    },
                    brandingColor: '#0077FF',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.clipchamp,
                    name: 'Clipchamp',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/clipchamp_24x.c65dac0a000ab12ac8dc18992da964c5.svg',
                    },
                    brandingColor: '#0C9D8C',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.lists,
                    name: 'Lists',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/lists_24x.6cb43f7df77f1c997f4c8fe7e93b8f3c.svg',
                    },
                    brandingColor: '#974B8B',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.yammer,
                    name: 'Yammer',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/yammer_24x.a06b4022cbdae2410e0acca4e087d460.svg',
                    },
                    brandingColor: '#0078D7',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.powerbi,
                    name: 'Power BI',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/powerbi_24x.6594f787c6ffbbc80b66e0610988a113.svg',
                    },
                    brandingColor: '#FFB900',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.bing,
                    name: 'Bing',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/bing_24x.165d62399a74f9d0f8ac1b4ce4037a2c.svg',
                    },
                    brandingColor: '#0C8484',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.msn,
                    name: 'MSN',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/msn_24x.fbf5b9064b91904dd7c018de6af843e2.svg',
                    },
                    brandingColor: '#1E1E1E',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.privacy,
                    name: 'Privacy',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/privacy_24x.2e633707c4ca67dd645fcd802f4ca7da.svg',
                    },
                    brandingColor: '#00AFF0',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.rewards,
                    name: 'Rewards',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/rewards_24x.436dd1a94e8799fae539a54a76ee66af.svg',
                    },
                    brandingColor: '#00AFF0',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.whiteboard,
                    name: 'Whiteboard',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/whiteboard_24x.8e9f0e2b4e42c8297f4835289fd88547.svg',
                    },
                    brandingColor: '#0C34FA',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
            {
                node: {
                    id: HubTileID.defender,
                    name: 'Defender',
                    icon: {
                        __typename: 'RemoteImage',
                        src: 'https://res-1.cdn.office.net/shellux/defender_24x.46e80ccde634e5ea47c305618ca536e2.svg',
                    },
                    brandingColor: '#3A80D2',
                    canLaunchOut: true,
                    isPinnable: true,
                    enablePlatformCommands: false,
                    isInUse: false,
                },
            },
        ];
        return launchTiles;
    }), 2), tileData = _a[0], setTileData = _a[1];
    return React.useMemo(function () {
        var e_3, _a;
        var defaultHubTileData = [];
        if (defaultApps) {
            var _loop_2 = function (edge) {
                var app = defaultApps.find(function (app) { return app.id === edge.node.id; });
                if (app) {
                    // Copy over the default pinned index
                    edge.node.pinnedIndex = app.pinnedIndex;
                    defaultHubTileData.push(edge);
                }
            };
            try {
                // Loop through all tiles and only include tiles found in the default apps
                for (var tileData_3 = __values(tileData), tileData_3_1 = tileData_3.next(); !tileData_3_1.done; tileData_3_1 = tileData_3.next()) {
                    var edge = tileData_3_1.value;
                    _loop_2(edge);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (tileData_3_1 && !tileData_3_1.done && (_a = tileData_3.return)) _a.call(tileData_3);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        return defaultHubTileData;
    }, [defaultApps, tileData]);
}
//# sourceMappingURL=useHubTileData.js.map